// src/components/FeatureSection.js
import React, { useState } from 'react';

const FeatureSection = ({ title, subtitle, features }) => {
  const [activeFeatureIndex, setActiveFeatureIndex] = useState(0);

  return (
    <section className="py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:text-center">
          <h2 className="text-3xl font-bold tracking-tight text-dark-text-primary sm:text-4xl">
            {title}
          </h2>
          <p className="mt-4 text-lg text-dark-text-secondary">{subtitle}</p>
        </div>
        <div className="mt-16 grid grid-cols-1 gap-12 lg:grid-cols-5 lg:gap-8 items-center">
          {/* Left Column: Feature Selector Buttons */}
          <div className="lg:col-span-2 flex flex-col gap-4">
            {features.map((feature, index) => (
              <button
                key={feature.title}
                onClick={() => setActiveFeatureIndex(index)}
                className={`p-6 rounded-xl text-left transition-all duration-300 ease-in-out border
                  bg-dark-card/40 backdrop-blur-lg transform-gpu hover:border-dark-accent-start/50
                  ${activeFeatureIndex === index ? 'border-dark-accent-start/70' : 'border-white/10'}
                `}
              >
                <h3 className="font-semibold text-lg text-dark-text-primary">{feature.title}</h3>
                <p className="text-sm mt-2 text-dark-text-secondary">{feature.description}</p>
              </button>
            ))}
          </div>

          {/* Right Column: Visual Display with Cross-Fade */}
          <div className="relative lg:col-span-3 h-[500px] bg-dark-card/30 rounded-2xl border border-white/10 shadow-inner overflow-hidden">
            {features.map((feature, index) => (
              <div
                key={feature.title}
                className={`absolute inset-0 transition-opacity duration-500 ease-in-out
                  ${activeFeatureIndex === index ? 'opacity-100' : 'opacity-0'}
                `}
              >
                <img src={feature.image} alt={feature.title} className="w-full h-full object-cover" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeatureSection;